import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { config, urls } from '../../../config';
import { useNewsletter } from './NewsletterContext';
import { emailSignUpGA } from '../../analytics';
import RedEye from '../RedEye/RedEye';
import { stripProtocol } from '../../utils/string';

export const NewsletterHOC = (OriginalComponent) => {
  const NewComponent = () => {
    const [validated, setValidated] = useState(false);
    const [fName, setFName] = useState('');
    const [email, setEmail] = useState('');
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState('');
    const [displayRedEye, setDisplayRedEye] = useState(false);

    const { hasSignedUpForDeals, setHasSignedUpForDeals } = useNewsletter();

    const handleSubmit = (event) => {
      const form = event.currentTarget;
      event.preventDefault();
      event.stopPropagation();

      if (!hasSignedUpForDeals && form.checkValidity() === true) {
        fetch(`${urls.newsletterSignup}?email=${encodeURIComponent(email)}&fname=${encodeURIComponent(fName)}`)
          .then((response) => response.json())
          .then((data) => {
            const isSuccessful = data.success === 1;

            setSuccess(isSuccessful);
            if (isSuccessful) {
              setMessage('');
              setHasSignedUpForDeals(true);
              emailSignUpGA('Footer');
            }
            if (!isSuccessful) {
              setMessage(data.errors[0].message);
              setDisplayRedEye(true);
            }
          })
          .catch((e) => {
            console.error('Could not fetch the content.', e);
            setDisplayRedEye(true);
          });
      }

      setValidated(true);
      setDisplayRedEye(true);
    };

    // Remove the UI after x seconds
    useEffect(() => {
      if (success) {
        const timer = setTimeout(() => {
          setSuccess(false);
        }, 10000);
        return () => clearTimeout(timer);
      }
    }, [success]);

    const hideNewsletter = (hasSignedUpForDeals && !success) || !config['forms.enableNewsletterSignup'];
    if (hideNewsletter) return null;

    return (
      <>
        <OriginalComponent
          hasSignedUpForDeals={hasSignedUpForDeals}
          success={success}
          validated={validated}
          handleSubmit={handleSubmit}
          fName={fName}
          setFName={setFName}
          email={email}
          setEmail={setEmail}
          message={message}
          displayRedEye={displayRedEye}
        />
        {displayRedEye && success && (
          <RedEye
            params={{
              nourl: 'email-sign-up',
              newsletter: 'sign-up',
              email,
              emailpermit: success ? 'yes' : 'no',
              email_signup_url: stripProtocol(window.location.href),
            }}
          />
        )}
      </>
    );
  };
  return NewComponent;
};

export const NewsletterProps = {
  hasSignedUpForDeals: PropTypes.bool,
  success: PropTypes.bool,
  validated: PropTypes.bool,
  handleSubmit: PropTypes.func,
  fName: PropTypes.string,
  setFName: PropTypes.func,
  email: PropTypes.string,
  setEmail: PropTypes.func,
  message: PropTypes.string,
  displayRedEye: PropTypes.bool,
};
